import de from './locales/de.json';
import en from './locales/en.json';

export const LOCALES = { de, en };

export const LANGUAGES = [
  { code: 'de', label: 'DE', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'en', label: 'EN', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'nl', label: 'NL', flag: '\u{1F1F3}\u{1F1F1}' },
  { code: 'pl', label: 'PL', flag: '\u{1F1F5}\u{1F1F1}' },
  { code: 'hu', label: 'HU', flag: '\u{1F1ED}\u{1F1FA}' },
  { code: 'ru', label: 'RU', flag: '\u{1F1F7}\u{1F1FA}' },
  { code: 'tr', label: 'TR', flag: '\u{1F1F9}\u{1F1F7}' },
  { code: 'fr', label: 'FR', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'es', label: 'ES', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'it', label: 'IT', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'ro', label: 'RO', flag: '\u{1F1F7}\u{1F1F4}' },
  { code: 'bg', label: 'BG', flag: '\u{1F1E7}\u{1F1EC}' },
  { code: 'ar', label: 'AR', flag: '\u{1F1F8}\u{1F1E6}' },
];
